<template>
  <v-card class="mb-4">
    <v-card-title class="text-h3">
      Система налогообложения
    </v-card-title>
    <v-card-text>
      <p class="grey--text">
        Проверьте, что выбранную систему поддерживает фискальный накопитель филиала.
      </p>

      <v-select
        v-model="localValue"
        :items="variants"
        item-text="name"
        item-value="value"
        label="Система налогообложения"
        outlined
        hide-details
        :disabled="saving"
        class="mb-4"
      />

      <v-btn
        color="primary"
        :loading="saving"
        :disabled="!localValue || localValue === value"
        @click="save"
      >
        Сохранить
      </v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
  import snackbarMessage from '@/mixins/snackbar-message'
  import SnoType from '@/models/enums/SnoType'
  import filialConnectionApi from '@/api/administration/filialConnection'

  export default {
    name: 'FilialConnectionSnoTypeBlock',
    mixins: [snackbarMessage],
    props: {
      filialId: { type: [Number, String], required: true },
      value: { type: String, default: null },
    },
    data () {
      return {
        localValue: this.value,
        saving: false,
        variants: SnoType.getAllVariants(),
      }
    },
    watch: {
      value (val) {
        this.localValue = val
      },
    },
    methods: {
      async save () {
        this.saving = true
        try {
          await filialConnectionApi.setSnoType(this.filialId, this.localValue)
          this.showSuccessMessage('Система налогообложения сохранена')
          this.$emit('updated')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.saving = false
      },
    },
  }
</script>
